import { Link } from "wouter";
import { ShieldCheck, DollarSign, ArrowRight } from "lucide-react";
import aboutus from '@/assets/banner4.png'

const CompanyOverview = () => {
    return (
        <section className="py-8 pink-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                    <div className="mb-10 lg:mb-0">
                        <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">About Axent Brokers</h2>
                        <h3 className="text-xl font-heading font-medium text-neutral-700 mb-4">Independent. Responsive. Built for Brokers.</h3>
                        <p className="text-lg text-neutral-800 mb-6">
                            Since 2016, Axent has supported brokers across the UK with fast, flexible cover from A-rated insurers.
                        </p>
                        <p className="text-lg text-neutral-800 mb-8">
                            We specialise in property and commercial lines - offering a simple way to get quotes, compare terms, and bind policies, all in one place.
                        </p>
                    </div>

                    <div className="relative h-64 sm:h-72 md:h-96 lg:h-full">
                        <div
                            className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-lg bg-cover bg-center"
                            style={{ backgroundImage: `url(${aboutus})` }}
                            role="img"
                            aria-label="Team of insurance brokers in a meeting"
                        ></div>
                    </div>
                </div>

                <div className="mt-12">
                    <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">Our Mission</h2>
                    <h3 className="text-xl font-heading font-medium text-neutral-700 mb-4">To make brokers' lives easier</h3>
                    <p className="text-lg text-neutral-800 mb-8">
                        We know brokers are under pressure to move quickly and deliver for clients. Our platform helps you do just that - with access to 180+ trades, smart quote comparisons, and a responsive team ready to help.
                    </p>

                    <p className="text-lg text-neutral-800 mb-8">
                        No red tape. No waiting. Just great service, every time.
                    </p>
                </div>

                <div>
                    <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">Why Brokers Choose Axent</h2>
                    <ul className="text-lg text-neutral-800 mb-6 px-10" style={{ listStyleType: 'disc' }}>
                        <li>Instant online quotes for 180+ trades</li>
                        <li>A-rated carriers and proven product range</li>
                        <li>Clear commission terms upfront</li>
                        <li>Support from real people when you need it</li>
                        <li>No volume targets or unfair tie-ins</li>
                    </ul>
                </div>

                <div>
                    <h2 className="text-3xl font-heading font-semibold text-neutral-800 mb-6">After Sales Service</h2>
                    {/*<p className="text-lg text-neutral-800 mb-8">*/}
                    {/*    You sell. We sort the rest.*/}
                    {/*</p>*/}

                    <p className="text-lg text-neutral-800 mb-8">
                        Once a policy is placed, we make servicing easy - all documentation is downloadable.
                    </p>

                    <p className="text-lg text-neutral-800 mb-8">
                        We also offer claims guidance and admin support, so your clients get a seamless experience from quote to renewal.
                    </p>

                </div>
                <div>
                    <p className="text-neutral-800 mb-8">
                        *subject to successful registration
                    </p>
                </div>

            </div>
        </section>
    );
};

export default CompanyOverview;
